import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { UserFacade } from '~/core/features'
import { ADMIN_ROLE } from '~const/index'

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  private readonly router = inject(Router)

  private readonly userFacade = inject(UserFacade)

  constructor() {}

  canActivate(): Observable<boolean> | boolean {
    return this.userFacade.user$.pipe(
      map(user => {
        if (user === null) {
          this.router.navigateByUrl('/')

          return false
        }

        if (user && user.role?.name !== ADMIN_ROLE) {
          this.router.navigateByUrl('/')

          return false
        }

        return true
      })
    )
  }
}
